import React from 'react';

import { Field } from '@hrlogics/react-components/form';

import { QueryMode } from 'src/api';
import { AutocompleteField } from 'src/components/finalForm';
import { useEmployersAutocomplete } from 'src/hooks/employer';
import { useCurrentUserPeo } from 'src/hooks/peo';
import { useCurrentUserPeoPayrollProvider } from 'src/hooks/peoPayrollProvider';

import { InboxFilterFieldProps, InboxFilterFormFields } from '../types';

export const InboxFilterEmployerField: React.FC<InboxFilterFieldProps> = ({ disabled }) => {
  const { peoId } = useCurrentUserPeo();
  const { peoPayrollProviderId } = useCurrentUserPeoPayrollProvider();

  const employersAutocompleteProps = useEmployersAutocomplete({
    queryFilter: searchText => ({
      filter: {
        AND: [
          {
            displayName: {
              contains: searchText,
              mode: QueryMode.Insensitive,
            },
          },
          ...(peoId ? [{ peoId: { equals: peoId } }] : []),
          ...(peoPayrollProviderId
            ? [
                {
                  OR: [
                    { peoPayrollProviderId: { equals: peoPayrollProviderId } },
                    { peo: { peoPayrollProviderId: { equals: peoPayrollProviderId } } },
                  ],
                },
              ]
            : []),
        ],
      },
    }),
  });

  return (
    <Field
      fullWidth
      component={AutocompleteField}
      name={InboxFilterFormFields.employer}
      label="Employer"
      disabled={disabled}
      multiple
      {...employersAutocompleteProps}
    />
  );
};
